import { api } from "./apiCore";

interface UnsubscribeResponse {
  success: boolean;
  message: string;
}

export const unsubscribeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    unsubscribeUser: builder.mutation<UnsubscribeResponse, string>({
      query: (token) => ({
        url: `/unsubscribe/${token}`,
        method: "POST",
      }),
      transformErrorResponse: (response) => {
        return {
          status: response.status,
          message: `Ошибка HTTP: ${response.status}`,
        };
      },
    }),
  }),
});

export const { useUnsubscribeUserMutation } = unsubscribeApi;
